// extracted by mini-css-extract-plugin
export var banner = "style-module--banner--c3fa7";
export var link = "style-module--link--2ec82";
export var linkContainer = "style-module--linkContainer--7d78d";